<template>
  <div id="demo-game" >
    <div class="game-screen" :style="{
        height: screen.height+'px',
        width: screen.width+'px'
      }">
      <!-- 角色圖 1 -->
      <div class="role-img-w role-img-w-1">
        <img class="role-img role-img-1" :src="roleImg1" alt="">
      </div>
      <!-- 角色圖 2 -->
      <div class="role-img-w role-img-w-2">
        <img class="role-img role-img-2" :src="roleImg2" alt="">
      </div>
      <div class="start-btn-wrapper" v-if="startBtn.show" :style="startBtnBox">
        <div class="start-btn" @click="btnStart()">
          <span v-html="startBtn.text"></span>
        </div>
      </div>
      <!-- 左下角 -->
      <div class="q-circle corner-LB hover" :style="corner" v-show="cornerBlock.show" @click="btnRecord">
        <div :style="cornerMicWrapper">
          <v-icon :style="cornerMic" :color="cornerMicInfo.color">mdi-microphone</v-icon>
        </div>
      </div>
      <!-- bot 回應的訊息框(上) -->
      <div class="reply-message-box hover" :style="replyBox" v-show="replyBlock.show">
        <div class="reply-message-content">
          <div class="content-text" v-html="replyBlock.text">
          </div>
        </div>
        <div
          class="reply-box-btns"
          :style="replyToolbarBox"
        >
          <!-- 重播按鈕 -->
          <v-icon
            color="#FFF"
            class="hover"
            @click="replayAllAudios"
          >mdi-replay</v-icon>
        </div>
      </div>
      <!-- bot 回應的訊息框(下) -->
      <div class="reply2-message-box hover" :style="reply2Box" v-show="replyBlock.show && replyBlock.textAppend">
        <div class="reply2-message-content">
          <div class="content-text" v-html="replyBlock.textAppend">
          </div>
        </div>
      </div>
      <!-- 最底下的訊息框 -->
      <div class="main-message-box hover" :style="msgBox" v-show="msgBlock.show" @click="btnMsgBox">
        <div class="main-message-content" v-html="msgBlock.text">
          {{msgBlock.text}}
        </div>
      </div>
      <!-- user message 的編輯框 -->
      <div class="main-message-edit-box" :style="msgEditBox" v-show="msgBlock.showEdit">
        <div class="main-message-edit-content">
          <textarea class="edit-area custom-scoll-normal" v-model="msgBlock.edit" ></textarea>
        </div>
      </div>
    </div>
    <div id="demo-game-audios">

    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

import { delay } from '@/lib/utils'
import { Howl, Howler } from 'howler'
import { storyStart, storyContinue } from '@/lib/story-api'
import { pick } from 'lodash'
import resizeMixins from '@/mixins/resize'

import dateTime from 'date-and-time'

const suuid = require('short-uuid')

function empty () {}

export default {
  name: 'DemoGame',
  mixins: [
    resizeMixins
  ],
  computed: {
    /**
     * 整個畫面相關
     */
    screen () {
      const paddingTop = 60
      const paddingBottom = 50
      const blockInterval = 15
      return {
        paddingTop,
        paddingBottom,
        blockInterval,
        contentHeight: this.$store.state.screen.height - (paddingTop + paddingBottom + blockInterval + blockInterval) - 1,
        height: this.$store.state.screen.height - 1,
        width: this.$store.state.screen.width - 1
      }
    },
    /**
     * 左下角的區域所需的資訊
     */
    cornerInfo () {
      const width = this.screen.width
      let size = width * this.cornerBlock.size
      if (size > 100) {
        size = 100
      } else if (size < 30) {
        size = 30
      }
      return {
        size
      }
    },
    /**
     * 左下角的 mic icon
     */
    cornerMicInfo () {
      const size = this.cornerInfo.size
      return {
        size: size / 2,
        color: '#0F3B75'
      }
    },
    /**
     * 左下角的區域的外框的 style
     */
    cornerMicWrapper () {
      const size = this.cornerInfo.size
      return {
        display: 'inline-block',
        marginTop: size / 2 - this.cornerMicInfo.size / 3 + 'px',
        marginLeft: size / 7 + 'px'
      }
    },
    /**
     * 左下角的 mic 的 style
     */
    cornerMic () {
      return { fontSize: this.cornerMicInfo.size + 'px' }
    },
    /**
     * 左下角的實際點擊區域
     */
    corner () {
      const width = this.screen.width
      const cSize = this.cornerInfo.size
      return {
        backgroundColor: '#F2C94B',
        width: cSize + 'px',
        height: cSize + 'px',
        borderRadius: `0 ${cSize}px 0 0`
      }
    },
    /**
     * 開始按鈕的 style
     */
    startBtnBox () {
      const { height: sHeight, paddingTop } = this.screen
      return {
        top: `${(sHeight - 100) / 2}px`
      }
    },
    /**
     * 畫面中間的 msg 區域 的 style
     */
    replyBox () {
      const { contentHeight: sHeight, paddingTop } = this.screen
      const { height, textAppend, toolbar } = this.replyBlock
      const bottomPad = toolbar.height + toolbar.pad * 2
      const h = height * sHeight - bottomPad
      const h2 = h / 2
      return {
        top: `${paddingTop}px`,
        height: h + 'px',
        paddingBottom: bottomPad + 'px'
      }
    },
    /**
     * 畫面中間的 msg 區域 的 底下工具列 的 style
     */
    replyToolbarBox () {
      const { toolbar } = this.replyBlock
      const { height, pad } = toolbar
      return {
        height: height + 'px',
        bottom: pad + 'px'
      }
    },
    /**
     * 畫面底下的 msg 區域 的 style
     */
    reply2Box () {
      const { contentHeight: sHeight, width: sWidth, paddingTop, blockInterval } = this.screen
      const { height, height2, textAppend } = this.replyBlock
      const top = paddingTop + blockInterval + (height * sHeight)
      const h = height2 * sHeight
      const h2 = h / 2
      return {
        top: `${top}px`,
        height: h + 'px'
      }
    },
    msgBoxInfo () {
      const { contentHeight: sHeight, width: sWidth, paddingBottom } = this.screen
      const { height, height2, textAppend } = this.replyBlock
      const width = this.screen.width
      const cSize = this.cornerInfo.size
      const mSize = sHeight * this.msgBlock.size
      const left = this.cornerBlock.show ? cSize + 5 : 20
      const widthMinus = this.cornerBlock.show ? cSize * 2 + 10 : 60
      return {
        bottom: paddingBottom,
        cSize,
        mSize,
        left,
        widthMinus
      }
    },
    msgBox () {
      const {
        bottom,
        mSize,
        left,
        widthMinus
      } = this.msgBoxInfo
      return {
        bottom: `${bottom}px`,
        height: mSize + 'px',
        left: `${left}px`,
        width: `calc(100vw - ${widthMinus}px)`
      }
    },
    msgEditBox () {
      const {
        bottom,
        mSize,
        left,
        widthMinus
      } = this.msgBoxInfo
      return {
        bottom: `${bottom + 15}px`,
        height: mSize + 'px',
        left: `${left - 10}px`,
        width: `calc(100vw - ${widthMinus}px)`
      }
    },
    roleImg1 () {
      return this.story.imgs[0]
    },
    roleImg2 () {
      return this.story.imgs[1]
    }
  },
  data () {
    return {
      c: {
        STORY_AUDIO: 1
      },
      user: {
        id: ''
      },
      story: {
        loading: false,

        id: 'PAPP_1',
        from: 'story',
        current: null,
        imgs: []
      },
      startBtn: {
        show: true,
        text: 'START'
      },
      replyBlock: {
        show: false,
        text: '',
        textAppend: '',
        height: 0.45,
        height2: 0.30,
        toolbar: {
          height: 24,
          pad: 10
        }
      },
      msgBlock: {
        show: false,
        showEdit: false,
        edit: '',
        text: '',
        size: 0.25,
        timeout: 3000,
        // 經過時間
        time: 0
      },
      cornerBlock: {
        show: false,
        size: 0.15
      },
      mic: {
        uploading: false,
        recording: false
      },
      player: {
        replayFlag: false,
        playing: false,
        cancel: false,
        wait: false,
        queue: []
      }
    }
  },
  mounted () {
    window.$demo = this
    document.title = '量子天命'
    console.log('page: $demo')
    this.handlePageArgs()
    if (!this.story.id) {
      this.startBtn.show = false
      this.replyBlock.text = '未指定故事ID<br>請在網址列上指定故事ID<br>像是 ...../story?sid=123'
      this.replyBlock.show = true
    }
    this.user.id = this.getUserId()
  },
  onBeforeDestory () {
    this.cancelRecording()
    this.pauseAllAudio()
  },
  methods: {
    /**
     * @param {Date} date
     * @returns {String}
     */
    getDateStr (date) {
      date = new Date(date)
      // 轉成 +8 時區的時間
      const offset = date.getTimezoneOffset() + 480
      date.setMinutes(date.getMinutes() + offset)
      return dateTime.format(date, 'YYYYMMDD-HHmmss')
    },
    getUserId () {
      let uid = null
      try {
        uid = window.localStorage.getItem('storyUserId')
      } catch (e) {
        console.error(e)
      }
      if (!uid) {
        uid = suuid.generate() + this.getDateStr(new Date())
        try {
          window.localStorage.setItem('storyUserId', uid)
        } catch (e) {
          console.error(e)
        }
      }
      return uid
    },
    handlePageArgs () {
      const opts = pick(this.$route.query, [
        'sid'
      ])
      console.log('opts', opts)
      const { sid } = opts
      this.story.id = sid
    },
    async btnStart () {
      try {
        this.startBtn.show = false
        await this.storyStart({
          onReceive: () => {
            this.cornerBlock.show = true
          }
        })
      } catch (e) {
        this.startBtn.show = true
        this.startBtn.text = '開始失敗<br>可能是故事ID有誤'
      }
    },
    btnMsgBox () {
      this.stopRecording()
    },
    btnRecord () {
      if (this.story.current) {
        this.startRecording()
      } else {
        this.storyStart()
      }
    },
    sim (text) {
      this.cancelRecording()
      this.storyContinue({ text })
    },

    async storyStart (opts = {}) {
      const onReceive = opts.onReceive || empty
      const results = await storyStart(this.story.id, {
        from: 'story',
        withText: true,
        userId: this.user.id
      })
      await onReceive(results)
      this.msgBlock.text = results.text
      const actions = results.actions || []
      this.story.current = results.next
      await this.handleActions(actions)
    },

    async storyResend (storyContinueOpts = {}) {
      const opts = storyContinueOpts
      opts.withText = true
      opts.from = this.story.from
      opts.current = this.story.current
      opts.userId = this.user.id
      const results = await storyContinue(this.story.id, opts)
      this.msgBlock.text = results.text
      const actions = results.actions || []
      await this.handleActions(actions)
    },

    async storyContinue (storyContinueOpts = {}) {
      const opts = { ...storyContinueOpts }
      opts.withText = true
      opts.from = this.story.from
      opts.current = this.story.current
      opts.userId = this.user.id
      const results = await storyContinue(this.story.id, opts)
      this.mic.uploading = false
      this.msgBlock.text = results.text
      this.cornerBlock.show = true
      const actions = results.actions || []
      this.story.current = JSON.parse(results.next)
      await this.handleActions(actions)
    },

    async handleActions (actions) {
      // 找出最後一個 play msg
      for (let i = actions.length - 1; i >= 0; i--) {
        const action = actions[i]
        if (action.type === 'play') {
          action.last = true
          break
        }
      }
      for (let i = 0; i < actions.length; i++) {
        const action = actions[i]
        try {
          await this.handleAction(action, actions, i)
        } catch (e) {
          console.error(e)
        }
      }
      try {
        await this.playAllAudios()
      } catch (e) {
        // ignore
      }
    },

    async handleAction (action, actions, i) {
      if (action.type === 'play' || action.type === 'change-img') {
        if (action.characters.length > 0) {
          this.story.imgs = action.characters.map((url) => url)
        }
        if (!this.mic.recording) {
          const prevAction = actions[i - 1]
          let addPrevText = false
          if (prevAction) {
            if (!prevAction.audio) {
              addPrevText = true
            }
          }
          this.replyBlock.show = true
          /** @type {String} */
          let text = (addPrevText ? this.replyBlock.text + '\n\n' : '') + action.text.trim()
          let append = ''
          if (action.last) {
            const sp = text.lastIndexOf('\n\n')
            if (sp !== -1) {
              append = text.substr(sp + 2).replace(/\n/g, '<br>')
              text = text.substr(0, sp).replace(/\n/g, '<br>') + '<br>'
            }
          }
          this.replyBlock.text = text
          this.replyBlock.textAppend = append

          if (action.audio) {
            this.addPlayAudio(action.audio)
          }
        }
      }
    },
    addPlayAudio (url) {
      this.player.queue.push(url)
    },
    /**
     * 重複檢查直到播放停止
     */
    checkUntilStop () {
      return new Promise((resolve) => {
        const $tt = setInterval(() => {
          if (!this.player.playing) {
            clearInterval($tt)
            resolve()
          }
        }, 50)
      })
    },
    async replayAllAudios (event) {
      if (!this.player.replayFlag) {
        this.player.replayFlag = true
        this.player.cancel = true
        this.pauseAllAudio()
        await this.checkUntilStop()
        this.player.cancel = false
        try {
          await this.playAllAudios()
        } catch (e) {
          // ignore
        }
        this.player.replayFlag = false
      }
    },
    /**
     * 開始播放音檔
     */
    async playAllAudios () {
      if (!this.player.playing) {
        this.player.playing = true
        this.player.cancel = false
        const $audios = new Array(this.player.queue.length)
        this.$audios = $audios
        for (let i = 0; i < $audios.length; i++) {
          const url = this.player.queue[i]
          $audios[i] = new Audio()
          $audios[i].src = url
          if (this.player.cancel) {
            this.player.playing = false
            return
          }
          try {
            $audios[i].play()
            $audios[i].pause()
          } catch (e) {
            // ..
          }
        }
        for (let i = 0; i < $audios.length; i++) {
          const url = this.player.queue[i]
          try {
            await this.playAudio(url, i)
            if (this.player.cancel) {
              this.player.playing = false
              return
            }
          } catch (e) {
            console.error(e)
          }
        }
      } else {
        // ...
      }
    },
    async playAudio (url, i) {
      this.pauseAllAudio()
      return await new Promise((resolve) => {
        const $audio = this.$audios[i]
        $audio.volume = 0.2
        $audio.src = url
        $audio.currentTime = 0
        $audio.play()
        $audio.onended = () => {
          resolve({ cancel: false })
        }
        $audio.onpause = () => {
          resolve({ cancel: true })
        }
        $audio.onstop = () => {
          resolve({ cancel: true })
        }
        $audio.onerror = () => {
          resolve({ error: true })
        }
      })
    },
    pauseAudio (i) {
      const $audios = this.$audios || []
      if ($audios[i]) {
        $audios[i].pause()
      }
    },

    pauseAllAudio () {
      const $audios = this.$audios || []
      for (const $audio of $audios) {
        $audio.pause()
      }
    },

    startRecording (text) {
      const mic = this.mic
      if (!mic.uploading && !mic.recording) {
        this.pauseAllAudio()
        text = text || '點擊停止錄音...'
        mic.recording = true
        this.msgBlock.show = true
        this.msgBlock.text = text
        this.cornerBlock.show = false
        this._startRecording()
      }
    },
    _startRecording () {
      return new Promise((resolve) => {
        // Request permissions to record audio
        navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
          const recorder = this.$recorder = new MediaRecorder(stream)

          // Set record to <audio> when recording will be finished
          recorder.addEventListener('dataavailable', e => {
            // audio.src = URL.createObjectURL(e.data)
            // console.log('dataavailable', e)
            this.mic.uploading = true
            this.storyContinue({
              audio: e.data
            }).then(() => {
              resolve(e.data)
            }).catch(() => {
              resolve(e.data)
            })
          })

          // Start recording
          recorder.start()
        })
      })
    },

    async stopRecording () {
      const mic = this.mic
      if (!mic.uploading && mic.recording) {
        mic.recording = false
        const recorder = this.$recorder
        this.msgBlock.text = '...uploading...'
        // Stop recording
        recorder.stop()
        // Remove “recording” icon from browser tab
        recorder.stream.getTracks().forEach(i => i.stop())
      }
    },

    async cancelRecording () {
      const mic = this.mic
      if (!mic.uploading && mic.recording) {
        mic.recording = false
        this.msgBlock.show = false
        this.cornerBlock.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#demo-game{
  background-color: grey;
  overflow: hidden;
}
.game-screen{
  position: absolute;
  top: 0;
  left: 0;
  width: 95vw;
  height: 95vh;
  background-color: #FFFCED;
}

.start-btn-wrapper{
  position: absolute;
  cursor: pointer;
  width: 100vw;
  text-align: center;
  .start-btn{
    display: inline-flex;
    width: 70vw;
    max-width: 250px;
    min-width: 100px;
    height: 100px;
    background-color: #444444CC;
    border-radius: 15px;
    justify-content: center;
    align-items: center;

    color: white;
    font-size: 20px;
    font-weight: bold;
  }
  .start-btn:hover{
    opacity: 0.8;
  }
}

// 顯示 bot 回應
.reply-message-box{
  position: absolute;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  left: 10vw;
  // top: by script;
  width: 80vw;
  background-color: #465A65;
  border-radius: 15px;
}
.reply-box-btns{
  position: absolute;
  right: 10px;
}
.reply-message-content{
  justify-content: center;
  font-size: 18px;
  color: #F2F7FC;
  overflow-y: auto;
  padding: 16px;
  font-weight: bold;
  text-align: left;
  .content-text{
    display: inline-block;
  }
  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    border-radius: 0px 15px 15px 0;
    background: #f1f1f1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    border-radius: 0px 15px 15px 0;
    background: #888;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

// 顯示 bot 回應 (附加段落)
.reply2-message-box{
  position: absolute;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  left: 10vw;
  // top: by script;
  width: 80vw;
  border-radius: 15px;
}
.reply2-message-content{
  justify-content: center;
  font-size: 17px;
  color: #F48F8F;
  overflow-y: auto;
  padding: 16px;
  font-weight: bold;
  .content-text{
    text-align: center;
  }
  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    border-radius: 0px 15px 15px 0;
    background: #f1f1f1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    border-radius: 0px 15px 15px 0;
    background: #888;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
// 最底下的框
.main-message-box{
  position: absolute;
  display: inline-flex;
  flex-direction: column;
  // left: by script;
  // bottom: by script;
  // width: by script;
  justify-content: center;
  background-color: #F2C94B;
  border-radius: 15px;
}
.main-message-content{
  display: inline-flex;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  color: #0F3B75;
  padding: 12px;
}
.main-message-edit-box{
  position: absolute;
  display: inline-flex;
  flex-direction: column;
  // left: by script;
  // bottom: by script;
  // width: by script;
  justify-content: center;
  background-color: #F2F7FC;
  border-radius: 15px;
  box-shadow: 2px 2px 2px 1px rgb(0, 0, 0, 0.3);
}
.main-message-edit-content{
  font-size: 20px;
  font-weight: bold;
  color: #0F3B75;
  padding: 12px;
  .edit-area{
    height: 100%;
    width: calc(100% - 10px);
    padding: 8px;
    resize: none;
  }
  .edit-area:focus{
    outline: none;
  }
}

.custom-scoll-normal{
  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

.hover:hover{
  cursor: pointer;
  opacity: 0.8;
}
.corner-LB{
  position: absolute;
  bottom: 0;
  left: 0;
}
.role-img-w{
  display: inline-block;
  position: absolute;
  top: 20vh;
}
.role-img-w-1{
  left: 7vw;
}
.role-img-w-2{
  right: 7vw;
}
.role-img{
  width: 40vw;
}
</style>
